export default __webpack_public_path__ + "static/nearlight_bg-9931fdd3f0940d49ab27c2d10dcc2018.jpg";